export default __webpack_public_path__ + "static/media/installation_firefox2.a4fd3f92.jpg";